import styled from 'styled-components';

import { TextButton } from '@riac/design-system';
import { Column } from '@riac/design-system';
import { Select, SelectSelectedValue, SelectTrigger } from '@riac/design-system';
import { SpinnerContainer } from '@riac/design-system';

export const EBookDownloadContainer = styled.div`
`;

export const EBookDownloadButton = styled(TextButton)`
  color: ${(props) => props.theme.black[70]};
  font-size: 1.8rem;
`;

export const EbookModalBody = styled(Column)`
  gap: 1em;  
  padding-top: 1em;
  max-width: 750px;

  ${SpinnerContainer} {
    height: unset;
  }
`;

export const PdfOptionsForm = styled.div`
  display: flex;
  flex-flow: row wrap;

  padding: 0.5em;
  border: solid 1px black;
`;

export const PdfOptionsFormSelect = styled(Select)`
  flex: 0 0 auto;
  width: 50%;

  padding: 0 0.25em;

  ${SelectTrigger} ${SelectSelectedValue} {
    font-size: 1.1em;
    padding: 5px;
  }

  ${({ theme }) => `${theme.tablet} { 
    ${SelectTrigger} ${SelectSelectedValue} {
      padding: 0.5em 1em;
      min-width: 200px;
      font-size: 1.4em;
    }
  }`}  
`;

export const PdfAdvancedOptionsToggle = styled.div`
  ${TextButton} {
    display: flex;
    gap: 0.5em;
    font-size: 1.8rem; 
    
    :hover
    {
      color: ${(props) => props.theme.blueLink};
    }
  }
`;
